import React, { useState } from 'react';
import './RegistrationPage.css';
import { Link, useNavigate } from 'react-router-dom';
import { signUp } from 'aws-amplify/auth';
import GlueLogo from '../glueLogo';

const RegistrationPage = () => {

  const [email, setEmail] = useState('');
  const [given_name, setGivenName] = useState('');
  const [family_name, setFamilyName] = useState('');
  const [password, setPassword] = useState('');

  // ✅ ORG TYPE
  const [organizationType, setOrganizationType] = useState('');

  // ✅ COMPANY DETAILS
  const [company_name, setCompanyName] = useState('');
  const [company_title, setCompanyTitle] = useState('');

  // ✅ REQUIREMENTS
  const [requirements, setRequirements] = useState([]);

  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  // =========================================
  // ✅ REQUIREMENT HANDLER
  // =========================================
  const handleRequirementChange = (value) => {

    setRequirements((prev) => {

      if (prev.includes(value)) {

        return prev.filter(
          (item) => item !== value
        );
      }

      return [...prev, value];
    });
  };

  // =========================================
  // ✅ SUBMIT
  // =========================================
  const handleSubmit = async (e) => {

    e.preventDefault();

    setErrorMessage('');
    setIsLoading(true);

    // ✅ VALIDATION
    if (
      !email ||
      !given_name ||
      !family_name ||
      !password ||
      !organizationType
    ) {

      setErrorMessage(
        'Please fill in all required fields'
      );

      setIsLoading(false);

      return;
    }

    try {

      // =====================================
      // ✅ FASTEST FIX
      // Use ONLY standard attributes
      // =====================================

      const response = await signUp({

        username: email,

        password,

        options: {

          userAttributes: {
            email,
            given_name,
            family_name,
            organizationType: organizationType,
            profileRequirement: requirements.join(', ')
          },
        },
      });

      console.log(
        'SIGNUP RESPONSE:',
        response
      );

      // =====================================
      // ✅ STORE EXTRA DETAILS
      // =====================================

      localStorage.setItem(
        "organizationType",
        organizationType
      );

      localStorage.setItem(
        "company_name",
        company_name
      );

      localStorage.setItem(
        "company_title",
        company_title
      );

      localStorage.setItem(
        "requirements",
        JSON.stringify(requirements)
      );

      localStorage.setItem(
        "userId",
        email
      );

      // =====================================
      // ✅ NAVIGATE
      // =====================================

      navigate(
        '/mfa',
        {
          state: {
            email,
            password
          }
        }
      );

    } catch (error) {

      console.error(
        'Error signing up:',
        error
      );

      setErrorMessage(
        error.message ||
        'An error occurred during registration'
      );

    } finally {

      setIsLoading(false);
    }
  };

  return (

    <div className="registration-container">

      <div className="registration-box">

        {/* ================================= */}
        {/* LOGO */}
        {/* ================================= */}

        <div className="header-name">

          <Link
            to="/"
            style={{
              textDecoration: 'none'
            }}
          >
            <GlueLogo height="50" />
          </Link>

        </div>

        <h1 className="header-name">
          Create an Account
        </h1>

        {/* ================================= */}
        {/* FORM */}
        {/* ================================= */}

        <form
          onSubmit={handleSubmit}
          autoComplete="off"
        >

          {/* FAKE FIELDS */}
          <input
            type="text"
            name="fakeusernameremembered"
            style={{ display: 'none' }}
          />

          <input
            type="password"
            name="fakepasswordremembered"
            style={{ display: 'none' }}
          />

          {/* EMAIL */}
          <label htmlFor="email">
            Email
          </label>

          <input
            id="email"
            type="email"
            autoComplete="new-email"
            placeholder="myemail@gmail.com"
            value={email}
            onChange={(e) =>
              setEmail(e.target.value)
            }
          />

          {/* FIRST NAME */}
          <label htmlFor="given_name">
            First Name
          </label>

          <input
            id="given_name"
            type="text"
            autoComplete="off"
            placeholder="First Name"
            value={given_name}
            onChange={(e) =>
              setGivenName(e.target.value)
            }
          />

          {/* LAST NAME */}
          <label htmlFor="family_name">
            Last Name
          </label>

          <input
            id="family_name"
            type="text"
            autoComplete="off"
            placeholder="Last Name"
            value={family_name}
            onChange={(e) =>
              setFamilyName(e.target.value)
            }
          />

          {/* COMPANY NAME */}
          <label htmlFor="company_name">
            Company Name
          </label>

          <input
            id="company_name"
            type="text"
            autoComplete="off"
            placeholder="Company Name"
            value={company_name}
            onChange={(e) =>
              setCompanyName(e.target.value)
            }
          />

          {/* COMPANY TITLE */}
          <label htmlFor="company_title">
            Company Title
          </label>

          <input
            id="company_title"
            type="text"
            autoComplete="off"
            placeholder="Company Title"
            value={company_title}
            onChange={(e) =>
              setCompanyTitle(e.target.value)
            }
          />

          {/* PASSWORD */}
          <label htmlFor="password">
            Password
          </label>

          <input
            id="password"
            type="password"
            autoComplete="new-password"
            placeholder="********"
            value={password}
            onChange={(e) =>
              setPassword(e.target.value)
            }
          />

          {/* ================================= */}
          {/* ORGANIZATION TYPE */}
          {/* ================================= */}

          <div className="form-section">

            <label htmlFor="organizationType">
              Organization Type
            </label>

            <select
              id="organizationType"
              className="custom-select"
              value={organizationType}
              onChange={(e) =>
                setOrganizationType(
                  e.target.value
                )
              }
            >

              <option value="">
                Select Organization Type
              </option>

              <option value="Corporate Organization">
                Corporate Organization
              </option>

              <option value="Government Organization">
                Government Organization
              </option>

            </select>
          </div>

          {/* ================================= */}
          {/* REQUIREMENTS */}
          {/* ================================= */}

          <div className="requirements-section">

            <label>
              Requirements
            </label>

            <div className="checkbox-group">

              {/* KYC */}
              <label className="checkbox-item">

                <input
                  type="checkbox"
                  checked={requirements.includes(
                    "KYC/AML"
                  )}
                  onChange={() =>
                    handleRequirementChange(
                      "KYC/AML"
                    )
                  }
                />

                <span>
                  KYC/AML
                </span>

              </label>

              {/* SUPPLIER */}
              <label className="checkbox-item">

                <input
                  type="checkbox"
                  checked={requirements.includes(
                    "Supplier Risk Management"
                  )}
                  onChange={() =>
                    handleRequirementChange(
                      "Supplier Risk Management"
                    )
                  }
                />

                <span>
                  Supplier Risk Management
                </span>

              </label>

              {/* LEGAL */}
              <label className="checkbox-item">

                <input
                  type="checkbox"
                  checked={requirements.includes(
                    "Legal Due Diligence"
                  )}
                  onChange={() =>
                    handleRequirementChange(
                      "Legal Due Diligence"
                    )
                  }
                />

                <span>
                  Legal Due Diligence
                </span>

              </label>

            </div>
          </div>

          {/* ERROR */}
          {errorMessage && (

            <div
              className="error-message"
              aria-live="polite"
            >
              {errorMessage}
            </div>
          )}

          {/* SUBMIT */}
          <button
            type="submit"
            className="sign-in-btn"
            disabled={isLoading}
          >

            {isLoading
              ? 'Signing up...'
              : 'Sign up'}

          </button>

          {/* LOGIN */}
          <div className="account-signup">

            Already have an account?

            <Link
              to="/login"
              style={{
                textDecoration: 'none',
                paddingLeft: 10
              }}
            >

              <span className="sign-up-btn">
                Login
              </span>

            </Link>

          </div>

        </form>
      </div>
    </div>
  );
};

export default RegistrationPage;